import { Link } from 'react-router-dom';
import { label } from '@entities/ksp/format';
import { useGetKspProjectsQuery } from '@shared/api/endpoints/ksp';
import { Card, Grid, Muted, Notice, Small, Stack } from '@widgets/ksp-workspace/parts';

export function ProjectsView() {
  const { data, error, isLoading } = useGetKspProjectsQuery();
  return (
    <Stack>
      <h1>ОСНОВА.КСП</h1>
      <Muted>Договорной график, принятый факт, прогноз и вехи строительных проектов.</Muted>
      {isLoading && <Notice>Загружаются доступные проекты…</Notice>}
      {error && (
        <Notice $error>Проекты недоступны. Повторите загрузку после восстановления связи.</Notice>
      )}
      <Grid>
        {data?.items.map((project) => (
          <Card key={project.id}>
            <h3>
              <Link to={`/agents/ksp/projects/${project.id}`}>{project.name}</Link>
            </h3>
            <Muted>
              {label(project.coverage ?? 'unknown')} · предупреждений:{' '}
              {project.warning_count ?? '—'}
            </Muted>
            <Small>Baseline: {project.baseline_id ? 'утверждён' : 'не выбран'}</Small>
            <Small>Дата состояния: {project.data_date ?? '—'}</Small>
            <Small>Обновление источника: {project.source_updated_at ?? '—'}</Small>
          </Card>
        ))}
      </Grid>
      {data?.items.length === 0 && (
        <Notice>Нет доступных проектов ПТО. Для работы требуется проект и проектный доступ.</Notice>
      )}
    </Stack>
  );
}
